import { EntityType } from "../../../../models";
import { Command2 } from "../../../../Command";
import { FlagActions } from "../../../flux/Flag";
import { ListActions } from "../../../flux/Grid";
import { ErrorActions } from "../../../flux/Error";
import { CommitFn } from "../../../../rest/Commit";
import { appNavigator } from "../../../routes";

// This command is executed from UI when we want to update Entity instance
export class UpsertCommand implements Command2<any, EntityType>
{
    private inProgressActions = new FlagActions();
    private listActions = new ListActions();
    private errorActions = new ErrorActions();
    
    constructor(private commit: CommitFn, private listDispatchToken: string, private inProgressDispatchToken: string, private errorDispatchToken)
    {
    }

    execute = (entityDraft: any, entityType: EntityType) => {
        this.inProgressActions.set(this.inProgressDispatchToken);
        this.commit({ type: entityType, entity: entityDraft })
            .then(res => {
                if(res.Success) return res[EntityType[entityType]];
                throw new Error(res.ErrorMessage);
            })
            .then(entity => {
                this.listActions.upsertItems([entity], entityType);
                appNavigator.goToEntityTab(entityType);
            })
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken ))
            .then(() => this.inProgressActions.reset(this.inProgressDispatchToken)); // finaly
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/commands/UpsertCommand.ts